import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivitySectionDirective } from '@core';
import { BuilderNodeComponent } from '@app/builder/builder-node.component';
import { BuilderRuntimeService } from '@app/builder/builder-runtime.service';
import { parseBuilderPage } from '@app/builder/builder-page';
import { BUILDER_PAGE_STYLE_TEXT } from '@app/builder/presentation';
import { LanguageService } from '@app/services/language';

@Component({
  selector: 'app-page-builder',
  templateUrl: './page-builder.component.html',
  styleUrl: './page-builder.component.scss',
  providers: [BuilderRuntimeService],
  imports: [BuilderNodeComponent, ActivitySectionDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.style]': 'pageStyles' },
})
export class PageBuilderComponent {
  protected readonly pageStyles = BUILDER_PAGE_STYLE_TEXT;
  public readonly pageId = input.required<string>();
  public readonly pageViewConfig = input.required<unknown>();

  protected readonly view = computed(() => parseBuilderPage(this.pageViewConfig()));
  protected readonly language = toSignal(inject(LanguageService).currentLanguage$, { requireSync: true });
}
